import React from "react";

class InterludeResourcesViewer extends React.Component {
  handleSwitchResource = index => this.props.onSwitchResource(index);

  render() {
    const { interludeDisplayed, isConclusion } = this.props;

    if (interludeDisplayed == null)
      return (
        <div className="bp3-text-muted text-center full-width no-resources">
          {isConclusion ? 'Cette conclusion ne semble pas avoir de ressources' : 'Cette interlude ne semble pas avoir de ressources'}
        </div>
      );
    return (
      <div className="col-xs-12 col-md-offset-3 col-md-6 monitor-img-container">
            {(!interludeDisplayed.type ||
              interludeDisplayed.type === "IMAGE") /** Use constants */ && (
                <img
                  src={interludeDisplayed.downloadURL}
                  className="monitor-image"
                  alt="Resource"
                />
              )}
            {interludeDisplayed.type === "VIDEO" /** Use constants */ && (
              <div>
                Interlude {interludeDisplayed.name} - Vidéo{" "}
                {interludeDisplayed.file}
              </div>
            )}
      </div>
    );
  }
}

export default InterludeResourcesViewer;
